/**
 * Router for Documents
 */

import { DocumentDetailView } from './pages/document-detail/DocumentDetailView'
import { DocumentOverview } from './pages/document-overview/DocumentOverview.page'
import { DocumentPreview } from './pages/document-preview/DocumentPreview'
import { DocumentsRoot } from './pages/documents-root/DocumentsRoot.page'

import type { RouteObject } from 'react-router-dom'

const documentsRoutes: RouteObject[] = [
  {
    path: 'documents',
    element: <DocumentsRoot />,
    children: [
      {
        path: 'personal',
        element: <DocumentOverview />,

        children: [
          {
            path: ':id',
            element: <DocumentDetailView />,
          },
          {
            path: 'preview/:fileId',
            element: <DocumentPreview />,
          },
        ],
      },
    ],
  },
]

export { documentsRoutes }
